import lines from '@/translations/en/role-capability-lines';

export default {
  domains: {
    iam: 'IAM',
    projects: 'Projects',
    sites: 'Sites',
    vendorManagement: 'Vendor Management',
    boq: 'BOQs',
    orders: 'Orders',
    paymentsPrsAps: 'Payments, PRs & APs',
    compliance: 'Compliance',
    returns: 'Returns',
    dashboards: 'Dashboards',
    cashflow: 'Cashflow',
    bankDraws: 'Bank Draws',
    navigation: 'Navigation',
  },
  scopes: {
    crossOrg: 'Cross-org',
    any: 'Any in org',
    assignedProject: 'Assigned project only',
    assignedSite: 'Assigned site only',
    none: 'None',
  },
  apiEnforced: 'API-enforced',
  apiEnforcedHint:
    'The frontend rule allows any record in the organisation; the API narrows it to this scope.',
  tiers: {
    platform: 'Platform',
    org: 'Organisation',
    project: 'Project',
    site: 'Site',
  },
  overview: {
    title: 'Role capabilities',
    tabs: {
      mine: 'What I can do',
      all: 'All roles',
    },
    domains: {
      iam: 'Organisation & users',
    },
    scopes: {
      mine: {
        site: 'On your sites',
        project: 'On your projects',
        org: 'Across the organisation',
      },
      all: {
        site: 'On their sites',
        project: 'On their projects',
        org: 'Across the organisation',
      },
    },
    roleNames: {
      ORG_ADMIN: 'Organisation Admin',
      ORG_FO: 'Organisation Finance Officer',
      ORG_FA: 'Organisation Finance Admin',
    },
    yourRoles: 'Your roles in {organisation}',
    heldOn: {
      project: '1 project | {count} projects',
      site: '1 site | {count} sites',
    },
    member: 'Member: no additional permissions',
    areaSearch: 'Search by area, e.g. Cashflow',
    areaSearchEmpty: 'No matching area',
    areas: 'Areas',
    allAreas: 'All areas',
    from: 'From {roles}',
    onlyRole: 'Only {role} can {capabilities}.',
    notListedMine: 'Areas not listed are not available to you.',
    notListedRole: 'Areas not listed are not available to this role.',
    tiers: {
      org: 'Organisation roles',
      project: 'Project roles',
      site: 'Site roles',
    },
    assigned: 'Assigned',
  },
  lines,
  matrix: {
    title: 'Permissions matrix',
    subtitle:
      // `{'@'}` is vue-i18n's literal: a bare `@` starts a linked message and fails to compile.
      "Read from the BudgetControl CASL rules in {'@'}boqnet/permissions.",
    capability: 'Capability',
    actionFilter: 'Actions',
    subjectFilter: 'Subjects',
    roleFilter: 'Roles',
    myRoles: 'Filter by my roles',
    myRolesHeading: 'Your roles',
    myRolesNone: 'You hold none of the roles in this matrix, so there is nothing to filter by.',
    simulator: 'Simulate roles',
    combined: 'Combined',
    legend: 'Legend',
    showDomain: 'Show {domain} capabilities',
    hideDomain: 'Hide {domain} capabilities',
    noMatches: 'No capabilities match the current filters',
  },
};
